'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Products;
(function (Products) {
    var MyProducts = /** @class */ (function () {
        function MyProducts() {
            var _this = this;
            $('.trigProductMainVisualDots').on('click', function (e) {
                _this.changeSelectDots(e);
            });
            $('.trigProductMainVisual').on('click', function (e) {
                _this.changeSelectThumbnail(e);
            });
            //
            $('.trigCloseModal').on('click', function () {
                $('.bulletModal').fadeOut('slow');
            });
        }
        // ドットアイコンを押したときの処理
        MyProducts.prototype.changeSelectDots = function (e) {
            var src = $(e.currentTarget).attr('data-image');
            $('.bulletProductMainVisual').css('background-image', "url(" + src + ")");
            this.openModal(src);
            $('.trigProductMainVisualDots').attr('data-is-active', 'false');
            $(e.currentTarget).attr('data-is-active', 'true');
        };
        // サムネイルを押したときの処理
        MyProducts.prototype.changeSelectThumbnail = function (e) {
            var src = $(e.currentTarget).attr('data-image');
            $('.bulletProductMainVisual').css('background-image', "url(" + src + ")");
            this.openModal(src);
            var index = $('.trigProductMainVisual').index(e.currentTarget);
            $('.trigProductMainVisualDots').attr('data-is-active', 'false');
            $('.trigProductMainVisualDots').eq(index).attr('data-is-active', 'true');
        };
        // モーダルウィンドウを開く処理
        MyProducts.prototype.openModal = function (src) {
            $('.bulletModalImage').attr('src', src);
            $('.bulletModal').fadeIn('slow');
        };
        return MyProducts;
    }());
    Products.MyProducts = MyProducts;
})(Products || (Products = {}));
exports.default = Products;
